// extracted by mini-css-extract-plugin
module.exports = {"payload":"ForwardStepType_payload__3sV5Y"};